import React from 'react';

import { ATTENDANCE_URL } from 'constants/endpoints';
import { DISPLAY_DATE_FORMAT } from 'constants/date';

import { pluralize } from 'utils/string';
import { getFirstDayOfMonth, getFormattedDate } from 'utils/date';

import Info from 'components/common/inputWrapper/components/Info';

interface Props {
  pendingLeaves?: number;
  pendingWorklogs?: number;
  user?: string;
  isLeaveIssuer?: boolean;
}

const PendingActionsInfo: React.FC<Props> = ({ pendingLeaves, pendingWorklogs, user, isLeaveIssuer }) => {
  // Return null if there are no pending actions
  if (!pendingLeaves && !pendingWorklogs) {
    return null;
  }

  // Construct the pending requests message
  const getPendingRequestsMessage = (): React.ReactNode => {
    if (pendingLeaves && pendingWorklogs) {
      return (
        <>
          <strong>
            {pendingLeaves} {pluralize('leave request', pendingLeaves)}
          </strong>
          &nbsp;and&nbsp;
          <strong>
            {pendingWorklogs} {pluralize('worklog', pendingWorklogs)}
          </strong>
        </>
      );
    }

    if (pendingLeaves) {
      return (
        <strong>
          {pendingLeaves} {pluralize('leave request', pendingLeaves)}
        </strong>
      );
    }

    if (pendingWorklogs) {
      return (
        <strong>
          {pendingWorklogs} {pluralize('worklog', pendingWorklogs)}
        </strong>
      );
    }

    return null;
  };

  const pendingRequestsMessage = getPendingRequestsMessage();

  // Construct the full message
  const getPendingActionsInfo = (): React.ReactNode => {
    if (pendingRequestsMessage) {
      const startDate = getFormattedDate(getFirstDayOfMonth(1), DISPLAY_DATE_FORMAT);

      return (
        <>
          <p>
            You cannot change the leave issuer until necessary action is taken.&nbsp;
            {user} has {pendingRequestsMessage} pending approval from {startDate}.
          </p>
          {isLeaveIssuer && (
            <p className="pt-8">
              <a href={ATTENDANCE_URL}>View Attendance</a>
            </p>
          )}
        </>
      );
    }

    return null;
  };

  return <Info message={getPendingActionsInfo()} shouldAlert={true} className="mt-4" />;
};

export default PendingActionsInfo;
